<template>
   <div>
       <row-line :label="$t('Project status')">{{ __attr(project.status) }}</row-line>
       <row-line :label="$t('Project type')">{{ __attr(project.type) }}</row-line>
        <row-line :label="$t('Project number')">
            <router-link
                :to="{ name: 'projects.show', params: {id: project.id} }"
                target="_blank">
                {{ project.code }}
            </router-link>
        </row-line>
        <row-line :label="$t('Project name')">
            <router-link
                :to="{ name: 'projects.show', params: {id: project.id} }"
                target="_blank">
                {{ project.name }}
            </router-link>
        </row-line>

        <row-line v-if="user" :label="$t('Project manager')">
            {{ user.name }}
        </row-line>

        <row-line :label="$t('Created at')" :line="false">{{ utcToLocalDateTimeLess(project.created_at) }}</row-line>
   </div>
</template>

<script>
import RowLine from './RowLine'
import { utcToLocalDateTimeLess } from '@utils'

export default {
  name: 'ProjectBasicInfo',
  components: {
    RowLine
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.project.user || null
    }
  },
  methods: {
    utcToLocalDateTimeLess
  }
}
</script>
